<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">所属部门：</span>-->
<!--        </div>-->
<!--        <el-select v-model="formData.deptCode" size="small" style="width: 280px">-->
<!--          <el-option v-for="item in deptCodeList" :key="item.code"-->
<!--                     :label="item.deptName" :value="item.code">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">所属岗位：</span>
        </div>
        <el-select v-model="formData.positionCode" size="small" style="width: 280px">
          <el-option v-for="item in positionList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">人员姓名：</span>
        </div>
        <el-select v-model="formData.code"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">薪资：</span>
        </div>
        <el-input v-model="formData.salary" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-person-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '人员管理'
        }],
        mainTitle: '添加人员',
        subheading: '',

        deptCodeList: [],
        positionList: [],
        responsiblePersonList: [],
        formData: {
          code: '',
          positionCode: '',
          positionName: '',
          salary: '',
        },
      }
    },
    created () {
      this.remoteMethod()
      this.getAttendancePositionList()
    },
    methods: {
      getAttendancePositionList () {
        this.$axios.post(api.getAttendancePositionList, {})
          .then(res => {
            let list = res.data.data
            list.map(v => {
              v._label = `${v.positionName} / ${v.deptName}`
            })
            this.positionList = list
          })
          .catch(errorHandler('获取岗位列表失败'))
      },

      remoteMethod (query) {
        this.getPersonList(query)
      },
      // 获取人员列表
      getPersonList (searchKey) {
        this.$axios.post(api.getAllPersonInfo, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName || ''}`
            })
            this.responsiblePersonList = list
          })
          .catch(errorHandler('获取人员列表失败'))
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-person-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.positionCode) {
          nError('请选择所属岗位')
          return false
        }
        if (!this.formData.code) {
          nError('请选择人员')
          return false
        }
        if (!this.formData.salary) {
          nError('请输入薪资')
          return false
        }
        this.$axios.post(api.addAttendancePerson, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendancePerson/AttendancePersonAdd.vue